// src/components/markets/CryptoChart.jsx
import React, { useState, useEffect } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { fetchAssetHistory } from '../../services/cryptoWS';

export default function CryptoChart({ symbol }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!symbol) return;

    let dead = false;
    async function loadHistory() {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchAssetHistory(symbol, '1d');
        if (dead) return;
        setHistory(data);
      } catch (err) {
        if (dead) return;
        setError(err.message);
      } finally {
        if (!dead) {
          setLoading(false);
        }
      }
    }

    loadHistory();
    return () => {
      dead = true;
    };
  }, [symbol]);

  if (loading) return <p className="muted small">Loading chart data...</p>;
  if (error) return <p className="error small">Error: {error}</p>;
  if (history.length === 0) return <p className="muted small">No historical data available.</p>;

  return (
    <div style={{ width: '100%', height: 300, marginTop: '20px' }}>
      <ResponsiveContainer>
        <LineChart data={history}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis 
            dataKey="time" 
            tickFormatter={(time) => new Date(time).toLocaleDateString()}
          />
          <YAxis 
            domain={['dataMin', 'dataMax']}
            tickFormatter={(price) => `$${price.toLocaleString()}`}
          />
          <Tooltip 
            labelFormatter={(time) => new Date(time).toLocaleDateString()}
            formatter={(value) => [`$${value.toLocaleString()}`, 'Price']}
          />
          <Legend />
          <Line type="monotone" dataKey="close" stroke="#8884d8" name="Close Price" dot={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
